import React, { useRef } from 'react';
import { Formik, Field, ErrorMessage, FormikProps } from 'formik';
import * as Yup from 'yup';
import InputBlock from '$/components/global/inputBlock';
import Modal from '$/components/global/modal';

import './index.scss';

interface IAddDealNoteProps {
  active: boolean;
  clientCompanyId: string;
  onAddSubmit: (id: string, note: string) => void;
  onCloseModal: () => void;
  title: string;
}

interface DealNoteValues {
  note: string;
}

export const AddNote: React.FC<IAddDealNoteProps> = props => {
  const { active, clientCompanyId, onAddSubmit, onCloseModal, title } = props;
  const initialValues = {
    note: '',
  } as DealNoteValues;

  const formikRef = useRef<FormikProps<DealNoteValues>>(null);

  const handleCloseModal = () => {
    if (formikRef && formikRef.current) {
      formikRef.current.resetForm();
    }

    onCloseModal();
  };

  const schema = Yup.object({
    note: Yup.string().required('Note is required.'),
  });

  return (
    <Modal title={title} active={active} forForm onClose={handleCloseModal}>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={schema}
        // tslint:disable-next-line: jsx-no-lambda
        onSubmit={(values: DealNoteValues, { resetForm }) => {
          onAddSubmit(clientCompanyId, values.note);
          resetForm();
        }}
        render={({ handleSubmit }: { [key: string]: any }) => (
          <form className="create-note" onSubmit={handleSubmit}>
            <InputBlock>
              <Field component="textarea" name="note" />
            </InputBlock>
            <ErrorMessage name="note">{msg => <div className="error error-message">{msg}</div>}</ErrorMessage>
            <div className="button_container">
              <button className="bix_button" type="submit">
                Add Note
              </button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};
